// Re-render Optimization 14.05.2020
import React from 'react'
import _filter from 'lodash/filter'
import _get from 'lodash/get'
import Modal from 'react-modal'
import { withRouter, Link } from 'react-router-dom'
import { connect } from 'react-redux'

import modalStyle from '../../../_common/core/modalStyle'
import Notifications from '../../_library/notifications/Notifications'
import Button from '../../_library/Button'
import LoadingBar from '../../_library/LoadingBar'

import { UPDATE_EVENT_STATUS, DUPLICATE_EVENT, DELETE_EVENT } from '../../../_common/redux/events/actions'
import { ROLES } from '../../constants/roles'

import Clipboard from '../../_library/Clipboard'
import { isFullVerified } from '../../utils/checkVerification'
import EventDuplicateModal from '../../events/EventDuplicateModal'
import ConfirmModal from '../../_library/ConfirmModal'
import { getTitle } from '../../utils/getTitle'
import { getFiveEvents } from '../../../_common/core/http_services/events'
import EventRow from '../../events/_library/EventRow'
import { createRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { Navigation } from 'swiper/modules'
import 'swiper/css/navigation'

@withRouter
@connect(
  state => ({
    user: state.auth.user,
    dynamicConfigs: state.launchDarklyInfo.launchDarklyFlags,
    isRnDomain: _get(state.shared, 'isRnDomain'),
    isMcDomain: _get(state.shared, 'isMcDomain'),
    MANA_CONSUMER: _get(state.shared, 'MANA_CONSUMER'),
  }),

  { UPDATE_EVENT_STATUS, DUPLICATE_EVENT, DELETE_EVENT },
)
export default class EventListNew extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      // Publish Event
      loading: {},
      selectedEvent: null,
      isPublish: false,
      showConfirmModal: false,
      showVerificationModal: false,
      showDuplicateEventModal: false,
      showDeleteConfirmationModal: false,
      deleting: false,
      filterFn: () => true,
      events: [],
      width: window.innerWidth,
    }
    this.ref = createRef()
  }

  listener = () => {
    this.setState({
      width: window.innerWidth,
    })
  }

  componentDidMount() {
    const configDocTitle = _get(this.props.configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle)
    this.fetchEvents()
    window.addEventListener('resize', this.listener)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.listener)
  }

  fetchEvents = async () => {
    try {
      const response = await getFiveEvents()
      this.setState({
        events: response.data.sort((a, b) =>
          a.startDate < b.startDate ? -1 : a.startDate > b.startDate ? 1 : 0,
        ),
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('🚀 ~ EventListNew ~ feetchEvents= ~ error:', error)
    }
  }

  handleDuplicateEvent = event => {
    this.setState({
      showDuplicateEventModal: true,
      selectedEvent: event,
    })
  }

  handleContextClick = event => {
    this.setState({
      showDeleteConfirmationModal: true,
      selectedEvent: event,
    })
  }

  closeDeleteConfirmationModal = () => {
    this.setState({
      showDeleteConfirmationModal: false,
      selectedEvent: null,
    })
  }

  deleteSelectedEvent = () => {
    const { DELETE_EVENT } = this.props
    const { selectedEvent } = this.state
    this.setState(
      {
        deleting: true,
      },
      () =>
        selectedEvent &&
        Promise.resolve(DELETE_EVENT(selectedEvent?.id))
          .then(event => {
            this.setState({ selectedEvent: null, deleting: false, showDeleteConfirmationModal: false })
            return event
          })
          .catch(e => {
            this.setState({ deleting: false, showDeleteConfirmationModal: false })
          }),
    )
  }

  handleDeleteConfirmationModal = value => {
    switch (value) {
      case 'ok': {
        this.deleteSelectedEvent()
        break
      }
      case 'cancel': {
        this.closeDeleteConfirmationModal()
        break
      }
      default:
        break
    }
  }

  handleDuplicateSubmit = (eId, data) => {
    const {
      history: { push },
      DUPLICATE_EVENT,
    } = this.props

    Promise.resolve(DUPLICATE_EVENT(eId, data))
      .then(event => {
        const id = _get(event, 'id')
        fbq('trackCustom', 'CreateEventSuccessful', {
          eventId: id,
        })
        const next = id ? `/event/${id}/details` : '/events'
        form_helper_reset()
        push(next)
        return event
      })
      .catch(e => {
        this.resetDuplicateForm()
      })
  }

  resetDuplicateForm() {
    const event = new CustomEvent('duplicate-error')
    document.dispatchEvent(event)
  }

  handleCloseDuplicateEvent = () => {
    this.setState({
      showDuplicateEventModal: false,
      selectedEvent: null,
    })
  }

  switchEvent = event => {
    this.setState({
      selectedEvent: event,
    })
  }

  handlePublish = (event, isPublish) => {
    const { user, configs } = this.props
    const canSkipIDVerification = _get(configs, 'behavior.skipIDVerificationStep', false)

    this.setState({
      selectedEvent: event,
      isPublish,
    })
    const isVerified = isFullVerified(_get(user, 'verifyInfo'))
    if (!isVerified && !canSkipIDVerification) {
      this.setState({
        showConfirmModal: false,
        showVerificationModal: true,
      })
    } else {
      this.setState({
        showConfirmModal: true,
      })
    }
  }

  handleCloseVerificationModal = () => {
    this.setState({ showVerificationModal: false })
  }

  handleIDVerify = () => {
    const {
      history: { push },
    } = this.props
    push('/account')
  }

  handleCloseConfirmModal = () => {
    this.setState({ showConfirmModal: false })
  }

  handleProcessEvent = () => {
    const { isPublish } = this.state
    this.handleCloseConfirmModal()
    this.processPublish(isPublish)
  }

  processPublish = async isPublish => {
    const { UPDATE_EVENT_STATUS } = this.props
    const { selectedEvent } = this.state

    const status = isPublish ? 'published' : 'unpublished'

    const loadingSetter = value => () => {
      this.setState({
        loading: {
          ...this.state.loading,
          [selectedEvent.id]: value,
        },
      })
    }

    try {
      loadingSetter(true)()
      await UPDATE_EVENT_STATUS(selectedEvent.id, status)
    } finally {
      loadingSetter(false)()
    }
  }

  getTableData = () => {
    const { user, configs, dynamicConfigs } = this.props
    const { filterFn, events } = this.state

    const userTfRole = _get(user, 'tfRole')
    const isTfSupport = ROLES.is_tf_support(userTfRole)

    const eventsPublished = _filter(events, event => {
      const permission = !!event ? event.self?.role : ''
      const isAdmin = permission === 'admin'
      const isOwner = permission === 'owner'
      const showAll = isAdmin || isOwner || isTfSupport
      const showPublishedOnly = event.status === 'published'
      const shouldDisplay = showAll || showPublishedOnly
      return shouldDisplay
    })

    const rows_filtered = eventsPublished.filter(filterFn)
    const isMobile = window.innerWidth < 768

    const rows = rows_filtered?.map((event, index) => {
      const { id } = event

      const permission = !!event ? event.self?.role : ''
      let redirectPath = '/performance'
      const supportRedirectPath = '/orders'

      if (permission === 'onsite') {
        redirectPath = '/checkin'
      }
      if (permission === 'curator') {
        redirectPath = '/invitations'
      }
      const isAdmin = permission === 'admin'
      const isOwner = permission === 'owner'
      const isSupport = ROLES.is_partial_support(permission) || ROLES.is_customer_support(permission)
      const promoterLink = event.self?.referral_link ? event.self?.referral_link : ''
      const isTfSupportAdminOrClientAdmin = ROLES.is_tf_support_admin_or_client_admin(userTfRole)

      return (
        <SwiperSlide key={id}>
          <EventRow
            key={id}
            index={index}
            event={event}
            autoRefresh={20 * 1000}
            dynamicConfigs={dynamicConfigs}
            configs={configs}
            promoterLink={promoterLink}
            isMobile={isMobile}
            showEventImage={false}
            isHome
          >
            <div className="btn-toolbar">
              <Link
                className="btn btn-lightpurple event-button-sm"
                to={'/event/' + event.id + (isSupport ? supportRedirectPath : redirectPath)}
              >
                <img alt="nodata" src={asset('/resources/images/eventmanage-ico.svg')} />
                Manage
              </Link>
              {(isAdmin || isOwner || isTfSupportAdminOrClientAdmin) && (
                <Link className="btn btn-blue event-button-sm" to={'/event/' + event.id + '/details'}>
                  <img alt="nodata" src={asset('/resources/images/edit-ico.svg')} />
                  Edit
                </Link>
              )}
              <Clipboard
                text={promoterLink}
                containerStyle={{ display: 'inline-flex', padding: 0, border: 'none' }}
                containerClassName="btn event-button-sm"
                isMobile={isMobile}
              >
                <div className="btn event-button-sm p,">
                  <i className="fa fa-files-o" aria-hidden="true" />
                  Promoter Link
                </div>
              </Clipboard>
            </div>
          </EventRow>
        </SwiperSlide>
      )
    })

    return rows
  }

  render() {
    const { configs } = this.props
    const {
      showVerificationModal,
      showConfirmModal,
      isPublish,
      showDuplicateEventModal,
      selectedEvent,
      deleting,
      events,
      width,
    } = this.state

    const eventCards = this.getTableData()

    const firstFive = eventCards.slice(0, 5)

    // Adjust breakpoints to show fewer slides with more space between them
    const showTwo = width >= 1000
    const showThree = width >= 1500
    const showFour = width >= 2000

    return (
      <div className="events-page" style={{ display: 'flex', justifyContent: 'center' }}>
        <Notifications />
        {showDuplicateEventModal && (
          <EventDuplicateModal
            showDuplicateEventModal={showDuplicateEventModal}
            handleCloseDuplicateEvent={this.handleCloseDuplicateEvent}
            onSubmit={this.handleDuplicateSubmit}
            selectedEvent={selectedEvent}
            events={events}
            switchEvent={this.switchEvent}
            configs={_get(configs, 'children.EventDuplicateModal')}
          />
        )}
        <div className="delete-confirm-modal">
          <ConfirmModal
            isOpen={this.state.showDeleteConfirmationModal}
            header={'Delete Event'}
            content={'Please confirm that you want to delete this event?'}
            actions={[
              { value: 'ok', label: 'Ok', className: 'btn btn-success btn-shadow' },
              { value: 'cancel', label: 'Cancel', className: 'btn btn-cancel btn-shadow' },
            ]}
            classNames={{
              modal: 'modal-dialog modal-trans ',
              container: 'modal-dialog',
            }}
            onAction={this.handleDeleteConfirmationModal}
          />
          {deleting && (
            <Modal
              className="modal-dialog modal-trans"
              style={modalStyle}
              isOpen={deleting}
              contentLabel="Modal"
              ariaHideApp={false}
            >
              <LoadingBar
                className="modal-dialog modal-trans"
                title={"Hold tight! We're getting your event list..."}
              />
            </Modal>
          )}
        </div>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={showVerificationModal}
          contentLabel="Modal"
          onRequestClose={this.handleCloseVerificationModal}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">ID Verification Needed</p>
                </div>
                <div className="modal-body">
                  <p>You need to verify your account in order to publish an event.</p>
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    <Button
                      className="btn btn-success btn-shadow"
                      type="button"
                      onClick={() => this.handleIDVerify()}
                    >
                      Verify
                    </Button>
                    <Button
                      className="btn btn-cancel btn-shadow"
                      type="button"
                      onClick={this.handleCloseVerificationModal}
                    >
                      Not Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={showConfirmModal}
          contentLabel="Modal"
          onRequestClose={this.handleCloseConfirmModal}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">Are you sure?</p>
                </div>
                <div className="modal-body">
                  <p>Please confirm that you want to {isPublish ? 'publish' : 'unpublish'} this event?</p>
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    <Button
                      className="btn btn-success btn-shadow"
                      type="button"
                      onClick={this.handleProcessEvent}
                    >
                      Yes
                    </Button>
                    <Button
                      className="btn btn-cancel btn-shadow"
                      type="button"
                      onClick={this.handleCloseConfirmModal}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        {Boolean(eventCards.length) && (
          <div className="events-list-container" style={{ margin: 'auto', marginBottom: '40px' }}>
            <div className="events-heading">
              <h3>Your Upcoming Events</h3>
            </div>
            <div className="body-panel-content">
              <Swiper
                spaceBetween={30}
                centeredSlides={false}
                slidesPerView={showFour ? 4 : showThree ? 3 : showTwo ? 2 : 1}
                navigation={true}
                modules={[Navigation]}
                className="events-list-swiper"
                style={{ height: 'auto' }}
                watchSlidesProgress={true}
                hideSlides={true}
              >
                {firstFive}
              </Swiper>
            </div>
            <div style={{ padding: '20px 20px 20px', textAlign: 'center' }}>
              <Link className="btn btn-seablue event-button-sm" to={'/events/'}>
                View All Events
              </Link>
            </div>
          </div>
        )}
      </div>
    )
  }
}
